import { Tooltip } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";

import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import useLocales from "../../hooks/useLocales";
import useCustomer from "../../hooks/useCustomer";
import { useUser } from "../../hooks";

const CustomerTitle = () => {
  const { translate } = useLocales();
  const { user } = useUser();
  const {
    customer,
    customerName,
    isActive,
    isVipCustomer,
    mhnNumber,
    isRealCustomer,
    customerCode,
  } = useCustomer(user.customerId);
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginLeft: "2rem",
      }}
    >
      Hoşgeldiniz,
      {isVipCustomer && (
        <Tooltip title={translate("resources.customers.isVip")}>
          <WorkspacePremiumIcon sx={{ color: "#0033a1" }} />
        </Tooltip>
      )}
      {customer && (
        <>
          <span
            style={{
              marginLeft: 5,
              fontWeight: "bold",
              maxWidth: "532px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {customerName}{" "}
          </span>
          <Tooltip
            title={
              isActive
                ? translate("resources.customers.active_customer")
                : translate("resources.customers.passive_customer")
            }
          >
            <CircleIcon
              style={{
                color: isActive ? "green" : "red",
                fontSize: 13,
                marginLeft: 5,
              }}
            />
          </Tooltip>
        </>
      )}
      <span style={{ marginLeft: 10, fontSize: 14 }}>
        {isRealCustomer ? mhnNumber : customerCode}
      </span>
    </div>
  );
};

export default CustomerTitle;
